function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .green-thumb-up{fill:#00c76b;}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "green-thumb-up",
  d: "M4.124,11H1.031A1.031,1.031,0,0,0,0,12.031v11.34A1.031,1.031,0,0,0,1.031,24.4H4.124Z",
  transform: "translate(0 0.34)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "green-thumb-up",
  d: "M23.051,10.722a4.124,4.124,0,0,0-3.133-1.443h-6.7V4.124C13.217,1.85,12.4,0,10.124,0a1.031,1.031,0,0,0-.995.76L6,11.34v13.4H18.811a4.1,4.1,0,0,0,4.076-3.5L24,14.029A4.124,4.124,0,0,0,23.051,10.722Z",
  transform: "translate(0.186 0)"
});

var SvgThumbUpGreen = function SvgThumbUpGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.229,
    height: 24.743,
    viewBox: "0 0 24.229 24.743",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbUpGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumb-up-green.b06bd839.svg";
export { ForwardRef as ReactComponent };